"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDate = exports.isValidDate = void 0;
var dateToUTC = function (date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
};
var isValidDate = function (dateString) {
  return new RegExp(/^(\d{4})-(\d{2})-(\d{2})$/).test(dateString) /* yyyy-mm-dd */ || new RegExp(/^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\dZ$/).test(dateString);
}; /* yyyy-mm-ddThh:mm:ssZ */
exports.isValidDate = isValidDate;
var parseDate = function (dateString) {
  var parsedTimestamp = Date.parse(dateString);
  if (isNaN(parsedTimestamp) || !(0, exports.isValidDate)(dateString)) {
    throw Error("Failed to convert ".concat(dateString, " to a valid date."));
  }
  var timeZonedDate = new Date(dateString);
  /* dates get converted as GMT and offsetted back for timezone, causing bugs
    The step below maintains the date while adding back the timezone.
       eg:
    - 2017-05-05 GMT+0  is reflected as 2017-05-04 GMT-7 (PDT)
    - dateToUTC will resolve this to: 2017-05-05 GMT-7
  */
  var date = dateToUTC(timeZonedDate);
  return date;
};
exports.parseDate = parseDate;